module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "boxs"
  }, [_c('div', {
    staticClass: "chose-btn flex m-b-14"
  }, [_c('div', {
    staticClass: "button",
    class: {
      active: _vm.type == 1
    },
    on: {
      "click": function($event) {
        _vm.type = 1
      }
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      active: _vm.type == 2
    },
    on: {
      "click": function($event) {
        _vm.type = 2
      }
    }
  }, [_vm._v("短信登录")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 1),
      expression: "type == 1"
    }]
  }, [_c('div', {
    staticClass: "input-box m-b-5",
    class: {
      error: !!_vm.phoneError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("当前手机已注册，请再输入密码登录")]), _vm._v(" "), _c('div', {
    staticClass: "input-box m-b-5",
    class: {
      error: !!_vm.passwordError
    }
  }, [((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "请输入登录密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.inputType = 'password'
      },
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "请输入登录密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "focus": function($event) {
        _vm.inputType = 'password'
      },
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "请输入登录密码",
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.inputType = 'password'
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-between m-b-68"
  }, [_c('div', {
    staticClass: "tips error"
  }, [_vm._v(_vm._s(_vm.passwordError))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": _vm.onForget
    }
  }, [_vm._v("忘记密码？")])]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn m-b-14",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即登录/注册")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 2),
      expression: "type == 2"
    }]
  }, [_c('div', {
    staticClass: "input-box m-b-5",
    class: {
      error: !!_vm.phoneError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("当前手机已注册，请验证手机登录")]), _vm._v(" "), _c('div', {
    staticClass: "captcha flex flex-between"
  }, [_c('div', {
    staticClass: "input-box",
    class: {
      error: !!_vm.captchaError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "captcha-img m-l-10",
    on: {
      "click": function($event) {
        _vm.captchasrc = '/wapi/base/captcha?' + (new Date).getTime()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchasrc
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    class: {
      error: _vm.captchaError
    }
  }, [_vm._v(_vm._s(_vm.captchaError))]), _vm._v(" "), _c('div', {
    staticClass: "input-box reg-ms flex",
    class: {
      error: !!_vm.verifyError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ms-text flex-shrink",
    on: {
      "click": _vm.onSend
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.time >= 0 ? '还剩 ' + _vm.time + ' 秒' : '发送验证码') + "\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    class: {
      error: _vm.verifyError
    }
  }, [_vm._v(_vm._s(_vm.verifyError))]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn m-b-14",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即登录/注册")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a46a337","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/yzlogin.vue
// module id = 867
// module chunks = 1